var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Chart',{staticClass:"mt-3",attrs:{"card":"","height":400,"series":[],"options":_vm.chartOptions,"header":_vm.$t('sales'),"error":_vm.requestChart.getError(),"loading":_vm.requestChart.getLoading(),"range":_vm.groupBy}})
}
var staticRenderFns = []

export { render, staticRenderFns }